export const ltv = 0.58

export const financed_cgi_app_link = "itauvarejo://ipcreditogarantiaimovel"
